<template>
  <div
    class="d-flex flex-column flex-root medhop-login-page"
    :data-theme="theme"
  >
    <span class="login-orb login-orb--top" aria-hidden="true"></span>
    <span class="login-orb login-orb--bottom" aria-hidden="true"></span>
    <button
      type="button"
      class="login-theme-toggle"
      :aria-label="themeToggleLabel"
      :title="themeToggleLabel"
      @click="toggleTheme"
    >
      <i
        :class="theme === 'dark' ? 'fas fa-sun' : 'fas fa-moon'"
        aria-hidden="true"
      ></i>
      <span>{{ theme === "dark" ? "Mode terang" : "Mode gelap" }}</span>
    </button>
    <div
      class="login login-1 d-flex flex-column flex-lg-row flex-column-fluid medhop-login-shell"
      :class="{
        'login-signin-on': this.state == 'signin',
        'login-signup-on': this.state == 'signup',
        'login-forgot-on': this.state == 'forgot',
      }"
      id="kt_login"
    >
      <div class="login-aside medhop-login-story">
        <div class="login-story-brand">
          <img src="/images/logo-medhop-transparent.png" alt="Medhop" />
        </div>

        <div class="login-story-copy">
          <span class="login-story-eyebrow">Vendor Portal Platform</span>
          <h1>Lebih cepat, terhubung, dan terpercaya.</h1>
          <p>
            Kelola pelayanan klinik, data pasien, jadwal, dan operasional dalam
            satu sistem yang aman dan mudah digunakan.
          </p>
          <div class="login-story-points" aria-label="Keunggulan Medhop">
            <span><i class="fas fa-shield-alt"></i> Data terlindungi</span>
            <span><i class="fas fa-heartbeat"></i> Operasional terintegrasi</span>
          </div>
        </div>

        <div class="login-story-footer">
          <span><i class="fas fa-globe-asia"></i> Indonesia</span>
          <span>Platform kesehatan digital</span>
        </div>
      </div>
      <div
        class="login-content medhop-login-content flex-row-fluid d-flex flex-column justify-content-center position-relative"
      >
        <div class="d-flex flex-column-fluid flex-center">
          <!--begin::Signin-->
          <div class="login-form login-signin medhop-auth-card">
            <form
              class="form"
              novalidate="novalidate"
              id="kt_login_signin_form"
              @submit.stop.prevent="onSubmitLogin()"
            >
              <div class="login-card-heading">
                <div class="login-clinic-logo">
                  <img
                    src="/images/logo-medhop-transparent.png"
                    alt="Medhop"
                  />
                </div>
                <span class="login-card-eyebrow">Portal Vendor SAAS</span>
                <h2>Selamat datang</h2>
                <p>Masuk untuk melanjutkan ke dashboard Medhop SAAS.</p>
              </div>
              <div class="form-group medhop-form-group">
                <label for="medhop-login-email">Email</label>
                <div
                  class="medhop-input-shell"
                  id="example-input-group-1"
                  label=""
                  label-for="example-input-1"
                >
                  <i class="far fa-envelope" aria-hidden="true"></i>
                  <input
                    id="medhop-login-email"
                    class="form-control"
                    type="email"
                    placeholder="nama@email.com"
                    name="email"
                    ref="email"
                    v-model="form.email"
                  />
                </div>
              </div>
              <div class="form-group medhop-form-group">
                <div class="login-password-label">
                  <label for="medhop-login-password">Password</label>
                </div>
                <div
                  class="medhop-input-shell medhop-password-shell"
                  id="example-input-group-2"
                  label=""
                  label-for="example-input-2"
                >
                  <i class="fas fa-lock" aria-hidden="true"></i>
                  <div class="input-group">
                    <input
                      id="medhop-login-password"
                      class="form-control"
                      :type="passwordIsVisible"
                      placeholder="Masukkan password"
                      name="password"
                      ref="password"
                      v-model="form.password"
                      autocomplete="off"
                    />
                    <div
                      class="input-group-prepend login-password-toggle"
                      role="button"
                      tabindex="0"
                      aria-label="Tampilkan atau sembunyikan password"
                      @click="
                        passwordIsVisible == 'password'
                          ? (passwordIsVisible = 'text')
                          : (passwordIsVisible = 'password')
                      "
                    >
                      <div class="input-group-text">
                        <template v-if="passwordIsVisible == 'password'">
                          <b-icon-eye-slash></b-icon-eye-slash>
                        </template>
                        <template v-if="passwordIsVisible == 'text'">
                          <b-icon-eye></b-icon-eye>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="login-submit-wrap">
                <button
                  ref="kt_login_signin_submit"
                  class="btn medhop-login-submit"
                >
                  <span>Masuk ke dashboard</span>
                  <i class="fas fa-arrow-right" aria-hidden="true"></i>
                </button>
                <p class="login-security-note">
                  <i class="fas fa-shield-alt" aria-hidden="true"></i>
                  Akses aman untuk tenaga dan pengelola fasilitas kesehatan
                </p>
              </div>
            </form>
          </div>
          <!--end::Signin-->
          <!--begin::Signup-->
          <div class="login-form login-signup medhop-auth-card">
            <form
              class="form"
              novalidate="novalidate"
              id="kt_login_signup_form"
              @submit.stop.prevent="onSubmitRegister()"
            >
              <div class="pb-13 pt-lg-0 pt-5">
                <h3
                  class="font-weight-bolder text-dark font-size-h4 font-size-h1-lg"
                >
                  Buat Akun
                </h3>
                <p class="text-muted font-weight-bold font-size-h4">
                  Lengkapi data untuk membuat akun Medhop SAAS
                </p>
              </div>
              <div class="form-group">
                <input
                  class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                  type="text"
                  placeholder="Nama lengkap"
                  name="fullname"
                  ref="fullname"
                  autocomplete="off"
                />
              </div>
              <div class="form-group">
                <input
                  class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                  type="email"
                  placeholder="Email"
                  name="email"
                  ref="remail"
                  autocomplete="off"
                />
              </div>
              <div class="form-group">
                <input
                  class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                  type="password"
                  placeholder="Password"
                  name="password"
                  ref="rpassword"
                  autocomplete="off"
                />
              </div>
              <div class="form-group">
                <input
                  class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                  type="password"
                  placeholder="Confirm password"
                  name="cpassword"
                  ref="cpassword"
                  autocomplete="off"
                />
              </div>
              <div class="form-group d-flex flex-wrap pb-lg-0 pb-3">
                <button
                  ref="kt_login_signup_submit"
                  class="btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-4"
                  style="width: 150px"
                >
                  Daftar
                </button>
                <button
                  type="button"
                  id="kt_login_signup_cancel"
                  class="btn btn-light-primary font-weight-bolder font-size-h6 px-8 py-4 my-3"
                  @click="showForm('signin')"
                >
                  Batal
                </button>
              </div>
            </form>
          </div>
          <!--end::Signup-->
          <!--begin::Forgot-->
          <div class="login-form login-forgot medhop-auth-card">
            <form
              class="form"
              novalidate="novalidate"
              id="kt_login_forgot_form"
              ref="kt_login_forgot_form"
            >
              <div class="login-card-heading login-forgot-heading">
                <div class="login-reset-icon">
                  <i class="fas fa-key" aria-hidden="true"></i>
                </div>
                <span class="login-card-eyebrow">Pemulihan akun</span>
                <h2>Lupa password?</h2>
                <p>Masukkan email Anda dan kami akan mengirimkan instruksi reset.</p>
              </div>
              <div class="form-group medhop-form-group">
                <label for="medhop-reset-email">Email</label>
                <input
                  id="medhop-reset-email"
                  class="form-control medhop-standalone-input"
                  type="email"
                  placeholder="Email"
                  name="email"
                  autocomplete="off"
                />
              </div>
              <div class="login-reset-actions">
                <button
                  type="button"
                  id="kt_login_forgot_submit"
                  class="btn medhop-login-submit"
                >
                  Kirim
                </button>
                <button
                  type="button"
                  id="kt_login_forgot_cancel"
                  class="btn medhop-login-secondary"
                  @click="showForm('signin')"
                >
                  Batal
                </button>
              </div>
            </form>
          </div>
          <!--end::Forgot-->
        </div>
        <div class="medhop-login-footer">
          <p>
            © 2026 Medhop Software. All Rights Reserved. <br />
            Powered by Wellmagic Media Digital.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- Load login custom page styles -->
<style lang="scss">
@import "@/assets/sass/pages/login/login-1.scss";

.medhop-login-page {
  --login-navy: #143263;
  --login-blue: #14608f;
  --login-teal: #1e958f;
  --login-accent: #35c9be;
  --login-page-bg: #09111f;
  --login-shell-bg: #0f1b2d;
  --login-story-bg: #102c3f;
  --login-content-bg: #0b1422;
  --login-card-bg: rgba(18, 31, 49, 0.96);
  --login-input-bg: #0c1727;
  --login-input-focus-bg: #101e31;
  --login-secondary-bg: #132238;
  --login-border: #2a3c52;
  --login-border-soft: rgba(100, 129, 158, 0.28);
  --login-text: #f3f7fb;
  --login-text-secondary: #b8c6d6;
  --login-muted: #91a2b5;
  --login-placeholder: #71849a;
  --login-icon: #8ea0b4;
  --login-story-pill: rgba(10, 24, 38, 0.66);
  --login-toggle-bg: rgba(15, 29, 47, 0.9);
  --login-shadow: rgba(0, 0, 0, 0.38);
  --login-logo-bg: rgba(255, 255, 255, 0.94);
  position: relative;
  min-height: 100vh;
  padding: 24px;
  overflow: hidden;
  background:
    radial-gradient(circle at 8% 10%, rgba(53, 201, 190, 0.13), transparent 24%),
    radial-gradient(circle at 92% 88%, rgba(29, 118, 168, 0.18), transparent 26%),
    var(--login-page-bg);
  font-family: "Poppins", "Inter", sans-serif;
  color: var(--login-text);
  transition: background-color 0.25s ease, color 0.25s ease;

  &[data-theme="light"] {
    --login-accent: #157d78;
    --login-page-bg: #edf3f8;
    --login-shell-bg: #ffffff;
    --login-story-bg: #e4f2f5;
    --login-content-bg: #f7f9fc;
    --login-card-bg: rgba(255, 255, 255, 0.97);
    --login-input-bg: #f5f8fb;
    --login-input-focus-bg: #ffffff;
    --login-secondary-bg: #ffffff;
    --login-border: #d5e0ea;
    --login-border-soft: rgba(20, 96, 143, 0.14);
    --login-text: #16243a;
    --login-text-secondary: #4d6077;
    --login-muted: #5d6f84;
    --login-placeholder: #8494a8;
    --login-icon: #71849b;
    --login-story-pill: rgba(255, 255, 255, 0.74);
    --login-toggle-bg: rgba(255, 255, 255, 0.92);
    --login-shadow: rgba(20, 50, 99, 0.13);
    --login-logo-bg: rgba(255, 255, 255, 0.78);
  }

  .login-orb {
    position: absolute;
    z-index: 0;
    width: 220px;
    height: 220px;
    border: 34px solid rgba(20, 96, 143, 0.08);
    border-radius: 50%;
    pointer-events: none;
  }

  .login-orb--top {
    top: -142px;
    left: -92px;
  }

  .login-orb--bottom {
    right: -108px;
    bottom: -142px;
    border-color: rgba(30, 149, 143, 0.09);
  }
}

.login-theme-toggle {
  position: absolute;
  z-index: 5;
  top: 40px;
  right: 40px;
  display: inline-flex;
  min-height: 42px;
  padding: 0 15px;
  border: 1px solid var(--login-border);
  border-radius: 999px;
  align-items: center;
  gap: 9px;
  color: var(--login-text);
  background: var(--login-toggle-bg);
  box-shadow: 0 8px 24px var(--login-shadow);
  font-family: inherit;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  backdrop-filter: blur(14px);
  transition: transform 0.2s ease, border-color 0.2s ease,
    background-color 0.2s ease;

  &:hover,
  &:focus-visible {
    border-color: var(--login-accent);
    outline: none;
    transform: translateY(-1px);
  }

  i {
    color: var(--login-accent);
    font-size: 13px;
  }
}

.medhop-login-shell {
  position: relative;
  z-index: 1;
  width: min(1280px, 100%);
  height: calc(100vh - 48px);
  margin: auto;
  overflow: hidden;
  border: 1px solid var(--login-border-soft);
  border-radius: 28px;
  background: var(--login-shell-bg);
  box-shadow: 0 28px 80px var(--login-shadow);
}

.login.login-1.medhop-login-shell .medhop-login-story {
  position: relative;
  display: flex;
  flex: 1 1 56%;
  width: auto;
  max-width: none;
  min-height: 620px;
  padding: 38px 46px;
  overflow: hidden;
  flex-direction: column;
  justify-content: space-between;
  background-image:
    linear-gradient(180deg, rgba(255, 255, 255, 0.02), var(--login-story-bg) 78%),
    linear-gradient(135deg, rgba(30, 149, 143, 0.28), rgba(20, 96, 143, 0.24) 52%, rgba(20, 50, 99, 0.35)) !important;
  background-color: var(--login-story-bg) !important;

  &::before,
  &::after {
    position: absolute;
    content: "";
    border-radius: 50%;
    pointer-events: none;
  }

  &::before {
    top: -150px;
    right: -115px;
    width: 420px;
    height: 420px;
    border: 64px solid rgba(255, 255, 255, 0.25);
  }

  &::after {
    right: 17%;
    bottom: 21%;
    width: 120px;
    height: 120px;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.38), rgba(255, 255, 255, 0));
    filter: blur(2px);
  }
}

.login-story-brand,
.login-story-copy,
.login-story-footer {
  position: relative;
  z-index: 1;
}

.login-story-brand img {
  width: 172px;
  height: 48px;
  padding: 7px 10px;
  border-radius: 12px;
  background: var(--login-logo-bg);
  object-fit: contain;
  object-position: left center;
}

.login-story-copy {
  max-width: 500px;
  margin: auto 0 80px;

  .login-story-eyebrow {
    display: inline-flex;
    margin-bottom: 16px;
    color: var(--login-accent);
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
  }

  h1 {
    max-width: 480px;
    margin: 0 0 18px;
    color: var(--login-text);
    font-size: clamp(34px, 4vw, 54px);
    font-weight: 700;
    line-height: 1.12;
    letter-spacing: -0.04em;
  }

  p {
    max-width: 470px;
    margin: 0;
    color: var(--login-text-secondary);
    font-size: 15px;
    line-height: 1.8;
  }
}

.login-story-points {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 26px;

  span {
    display: inline-flex;
    min-height: 38px;
    padding: 9px 13px;
    align-items: center;
    gap: 8px;
    border: 1px solid var(--login-border-soft);
    border-radius: 999px;
    color: var(--login-text);
    background: var(--login-story-pill);
    font-size: 12px;
    font-weight: 600;
    backdrop-filter: blur(10px);
  }

  i {
    color: var(--login-accent);
  }
}

.login-story-footer {
  display: flex;
  color: var(--login-text-secondary);
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  font-weight: 500;

  span {
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }

  i {
    color: var(--login-accent);
  }
}

.login.login-1.medhop-login-shell .medhop-login-content {
  flex: 0 1 44%;
  width: auto;
  min-width: 410px;
  padding: 48px 36px 32px;
  overflow-y: auto !important;
  background: var(--login-content-bg);

  .flex-center {
    width: 100%;
    margin: auto 0;
  }
}

.login.login-1 .medhop-auth-card {
  width: min(100%, 440px);
  padding: 34px 36px 30px;
  border: 1px solid var(--login-border-soft);
  border-radius: 24px;
  background: var(--login-card-bg);
  box-shadow: 0 18px 50px var(--login-shadow);

  .form {
    width: 100%;
    max-width: none;
  }

  .text-dark,
  .text-dark-75 {
    color: var(--login-text) !important;
  }

  .text-muted {
    color: var(--login-muted) !important;
  }

  .form-control-solid {
    border-color: var(--login-border) !important;
    color: var(--login-text) !important;
    background: var(--login-input-bg) !important;

    &::placeholder {
      color: var(--login-placeholder) !important;
    }
  }
}

.login-card-heading {
  margin-bottom: 28px;

  .login-clinic-logo {
    display: flex;
    width: 100%;
    height: 58px;
    margin-bottom: 20px;
    align-items: center;

    img {
      max-width: 190px;
      max-height: 58px;
      padding: 7px 10px;
      border-radius: 12px;
      background: var(--login-logo-bg);
      object-fit: contain;
      object-position: left center;
    }
  }

  .login-card-eyebrow {
    display: block;
    margin-bottom: 7px;
    color: var(--login-accent);
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.13em;
    text-transform: uppercase;
  }

  h2 {
    margin: 0 0 8px;
    color: var(--login-text);
    font-size: 29px;
    font-weight: 700;
    line-height: 1.25;
    letter-spacing: -0.025em;
  }

  p {
    margin: 0;
    color: var(--login-muted);
    font-size: 13px;
    line-height: 1.65;
  }
}

.medhop-form-group {
  margin-bottom: 18px;

  > label,
  .login-password-label label {
    margin: 0 0 8px;
    color: var(--login-text-secondary);
    font-size: 12px;
    font-weight: 600;
  }
}

.login-password-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.medhop-input-shell {
  position: relative;
  display: flex;
  min-height: 50px;
  align-items: center;
  border: 1px solid var(--login-border);
  border-radius: 14px;
  background: var(--login-input-bg);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;

  > i {
    position: absolute;
    z-index: 2;
    left: 16px;
    color: var(--login-icon);
    font-size: 14px;
  }

  &:focus-within {
    border-color: rgba(30, 149, 143, 0.72);
    background: var(--login-input-focus-bg);
    box-shadow: 0 0 0 4px rgba(30, 149, 143, 0.1);

    > i {
      color: var(--login-accent);
    }
  }

  .form-control {
    height: 48px;
    padding: 0 16px 0 43px !important;
    border: 0 !important;
    border-radius: 14px !important;
    color: var(--login-text);
    background: transparent !important;
    box-shadow: none !important;
    font-size: 13px;

    &::placeholder {
      color: var(--login-placeholder);
    }
  }
}

.medhop-password-shell {
  .input-group {
    width: 100%;
  }

  .form-control {
    padding-right: 50px !important;
  }
}

.login-password-toggle {
  position: absolute;
  z-index: 3;
  top: 0;
  right: 0;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  .input-group-text {
    padding: 0;
    border: 0 !important;
    color: var(--login-icon);
    background: transparent !important;
  }
}

.login-submit-wrap {
  margin-top: 24px;
}

.medhop-login-submit {
  display: inline-flex !important;
  width: 100%;
  min-height: 50px;
  padding: 0 20px !important;
  border: 0 !important;
  border-radius: 14px !important;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #fff !important;
  background: linear-gradient(135deg, var(--login-navy), var(--login-blue), var(--login-teal)) !important;
  box-shadow: 0 12px 25px rgba(20, 96, 143, 0.23);
  font-size: 13px !important;
  font-weight: 700 !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover,
  &:focus {
    color: #fff !important;
    transform: translateY(-1px);
    box-shadow: 0 16px 30px rgba(20, 96, 143, 0.28);
  }
}

.login-security-note {
  display: flex;
  margin: 18px 0 0;
  align-items: flex-start;
  justify-content: center;
  gap: 8px;
  color: var(--login-muted);
  font-size: 10px;
  line-height: 1.5;
  text-align: center;

  i {
    margin-top: 2px;
    color: var(--login-accent);
  }
}

.login-reset-icon {
  display: inline-flex;
  width: 48px;
  height: 48px;
  margin-bottom: 20px;
  border-radius: 14px;
  align-items: center;
  justify-content: center;
  color: var(--login-accent);
  background: rgba(30, 149, 143, 0.1);
  font-size: 18px;
}

.medhop-standalone-input {
  height: 50px !important;
  padding: 0 16px !important;
  border: 1px solid var(--login-border) !important;
  border-radius: 14px !important;
  color: var(--login-text) !important;
  background: var(--login-input-bg) !important;
  box-shadow: none !important;

  &:focus {
    border-color: rgba(30, 149, 143, 0.72) !important;
    background: var(--login-input-focus-bg) !important;
    box-shadow: 0 0 0 4px rgba(30, 149, 143, 0.1) !important;
  }
}

.login-reset-actions {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 10px;
  margin-top: 24px;
}

.medhop-login-secondary {
  min-height: 50px;
  padding: 0 18px !important;
  border: 1px solid var(--login-border) !important;
  border-radius: 14px !important;
  color: var(--login-text) !important;
  background: var(--login-secondary-bg) !important;
  font-size: 13px !important;
  font-weight: 700 !important;
}

.medhop-login-footer {
  display: flex !important;
  margin-top: 24px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: var(--login-muted);
  font-size: 10px;
  text-align: center;

  p {
    margin: 0;
    font-size: inherit !important;
  }
}

@media (max-width: 991.98px) {
  .medhop-login-page {
    padding: 16px;
    overflow: auto;
  }

  .login-theme-toggle {
    top: 28px;
    right: 28px;
  }

  .medhop-login-shell {
    min-height: calc(100vh - 32px);
  }

  .login.login-1.medhop-login-shell .medhop-login-story {
    display: flex !important;
    flex: 0 0 auto;
    width: 100%;
    min-height: 220px;
    padding: 28px 32px;
  }

  .login-story-copy {
    max-width: 620px;
    margin: 34px 0 0;

    h1 {
      font-size: 34px;
    }

    p,
    .login-story-points {
      display: none;
    }
  }

  .login-story-footer {
    display: none;
  }

  .login.login-1.medhop-login-shell .medhop-login-content {
    flex: 1 1 auto;
    width: 100%;
    min-width: 0;
    padding: 28px 22px;
  }
}

@media (max-width: 575.98px) {
  .medhop-login-page {
    padding: 0;
    background: var(--login-page-bg);
  }

  .login-theme-toggle {
    position: fixed;
    top: 16px;
    right: 16px;
    min-width: 42px;
    padding: 0;
    justify-content: center;

    span {
      display: none;
    }
  }

  .medhop-login-shell {
    min-height: 100vh;
    border: 0;
    border-radius: 0;
    box-shadow: none;
  }

  .login.login-1.medhop-login-shell .medhop-login-story {
    min-height: 170px;
    padding: 24px;
  }

  .login-story-brand img {
    width: 140px;
    height: 38px;
  }

  .login-story-copy {
    margin-top: 24px;

    .login-story-eyebrow {
      margin-bottom: 8px;
      font-size: 9px;
    }

    h1 {
      font-size: 26px;
    }
  }

  .login.login-1.medhop-login-shell .medhop-login-content {
    padding: 20px 14px 18px;
    justify-content: flex-start !important;
  }

  .login.login-1 .medhop-auth-card {
    padding: 26px 22px;
    border-radius: 20px;
    box-shadow: 0 12px 34px rgba(20, 50, 99, 0.08);
  }

  .login-card-heading h2 {
    font-size: 25px;
  }

  .login-reset-actions {
    grid-template-columns: 1fr;
  }
}
</style>

<script>
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import ApiService from "@/core/services/api.service.js";
import JwtService from "@/core/services/jwt.service";

// FormValidation plugins
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import SubmitButton from "@/assets/plugins/formvalidation/dist/es6/plugins/SubmitButton";

import KTUtil from "@/assets/js/components/util";
import { mapGetters, mapState } from "vuex";
import { LOGIN, LOGOUT, REGISTER } from "@/core/services/store/auth.module";
import Swal from "sweetalert2";

export default {
  name: "login-1",
  data() {
    return {
      state: "signin",
      // Remove this dummy login info
      form: {
        email: "",
        password: "",
      },
      passwordIsVisible: "password",
      theme: "dark",
    };
  },
  computed: {
    ...mapState({
      errors: (state) => state.auth.errors,
    }),
    ...mapGetters(["currentUser"]),

    backgroundImage() {
      return process.env.BASE_URL + "images/logo-medhop-transparent.png";
    },
    themeToggleLabel() {
      return this.theme === "dark"
        ? "Aktifkan mode terang"
        : "Aktifkan mode gelap";
    },
  },
  mounted() {
    const savedTheme = window.localStorage.getItem("medhop-login-theme");
    this.theme = savedTheme === "light" ? "light" : "dark";

    const signin_form = KTUtil.getById("kt_login_signin_form");
    const signup_form = KTUtil.getById("kt_login_signup_form");
    const forgot_form = KTUtil.getById("kt_login_forgot_form");

    this.fv = formValidation(signin_form, {
      fields: {
        email: {
          validators: {
            notEmpty: {
              message: "Email",
            },
          },
        },
        password: {
          validators: {
            notEmpty: {
              message: "Password wajib diisi",
            },
          },
        },
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap(),
      },
    });

    this.fv1 = formValidation(signup_form, {
      fields: {
        fullname: {
          validators: {
            notEmpty: {
              message: "Nama harus diisi",
            },
          },
        },
        email: {
          validators: {
            notEmpty: {
              message: "Email harus diisi",
            },
            emailAddress: {
              message: "The value is not a valid email address",
            },
          },
        },
        password: {
          validators: {
            notEmpty: {
              message: "Password harus diisi",
            },
          },
        },
        cpassword: {
          validators: {
            notEmpty: {
              message: "Confirm password harus diisi",
            },
            identical: {
              compare: function () {
                return signup_form.querySelector('[name="password"]').value;
              },
              message: "Konfirmasi password dan password harus sama",
            },
          },
        },
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap(),
      },
    });

    this.fv2 = formValidation(forgot_form, {
      fields: {
        email: {
          validators: {
            notEmpty: {
              message: "Email is required",
            },
            emailAddress: {
              message: "The value is not a valid email address",
            },
          },
        },
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap(),
      },
    });
  },
  methods: {
    toggleTheme() {
      this.theme = this.theme === "dark" ? "light" : "dark";
      window.localStorage.setItem("medhop-login-theme", this.theme);
    },

    showForm(form) {
      this.state = form;
      var form_name = "kt_login_" + form + "_form";
      KTUtil.animateClass(
        KTUtil.getById(form_name),
        "animate__animated animate__backInUp"
      );
    },

    onSubmitLogin() {
      // this.fv.validate();
      SwalLoading.fire();

      // this.fv.on("core.form.valid", () => {
      var email = this.form.email;
      var password = this.form.password;

      // clear existing errors
      this.$store.dispatch(LOGOUT);

      // dummy delay
      setTimeout(() => {
        // send login request
        this.$store
          .dispatch(LOGIN, { email, password })
          // go to which page after successfully login
          .then(() => {
            let access_right, role_right;
            ApiService.get("users/me").then((data) => {
              ApiService.get("users/" + data.data.data.id).then(
                (response) => {
                  if (data.data.data) {
                    ApiService.get("roles/" + data.data.data.role_id).then(
                      (result) => {
                        access_right = response.data.meta.access_right_display;
                        role_right = result.data.meta.access_right_display;

                        let merge = [...access_right, ...role_right];

                        window.localStorage.setItem(
                          "access_right_display",
                          JSON.stringify(merge)
                        );

                        let user = data.data.data;
                        JwtService.setUser(JSON.stringify(user));

                        this.$router.push({ name: "registrants" });
                        SwalLoading.close();
                      }
                    );
                  } else if (!data.data.data.position_id) {
                    window.localStorage.setItem(
                      "access_right",
                      response.data.meta.access_right
                    );

                    window.localStorage.setItem(
                      "access_right_display",
                      JSON.stringify(response.data.meta.access_right_display)
                    );

                    let user = data.data.data;
                    access_right = response.data.meta.access_right;
                    user.access_right = response.data.meta.access_right;
                    JwtService.setUser(JSON.stringify(user));

                    for (let z = 0; z < 20; z++) {
                      if (z == 19) {
                        this.$router.push({ name: "registrants" });
                        SwalLoading.close();
                      }
                    }
                  }
                }
              );
            });
          });
      }, 100);
    },

    onSubmitRegister() {
      this.fv1.validate();

      this.fv1.on("core.form.valid", () => {
        const email = this.$refs.remail.value;
        const password = this.$refs.rpassword.value;
        const name = this.$refs.fullname.value;

        // clear existing errors
        this.$store.dispatch(LOGOUT);

        // set spinner to submit button
        const submitButton = this.$refs["kt_login_signup_submit"];
        submitButton.classList.add("spinner", "spinner-light", "spinner-right");

        // dummy delay
        setTimeout(() => {
          // send register request
          this.$store
            .dispatch(REGISTER, {
              email: email,
              name: name,
              password: password,
            })
            .then(() => this.$router.push({ name: "registrants" }))
            .catch((error) => {
              let message = "Registrasi gagal";
              if (error) {
                if (typeof error === "string") {
                  message = error;
                } else if (error.message) {
                  message = error.message;
                } else if (error.errors) {
                  message = Object.values(error.errors)
                    .flat()
                    .join(" \n");
                }
              }
              Swal.fire({
                title: "",
                text: message,
                icon: "error",
                confirmButtonClass: "btn btn-secondary",
              });
            })
            .finally(() => {
              submitButton.classList.remove(
                "spinner",
                "spinner-light",
                "spinner-right"
              );
            });
        }, 2000);
      });

      this.fv1.on("core.form.invalid", () => {
        Swal.fire({
          title: "",
          text: "Please, provide correct data!",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
      });
    },
  },
};
</script>
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
      });
    },
  },
};
</script>
